import useTheme$1 from './useThemeWithoutDefault.js';
import createTheme from './createTheme/createTheme.js';

const systemDefaultTheme = createTheme();
function useTheme(defaultTheme = systemDefaultTheme) {
  return useTheme$1(defaultTheme);
}

export { useTheme as default, systemDefaultTheme };
//# sourceMappingURL=useTheme.js.map
